
import Api from '@/api'
import Constants from '@/util/constants'

export default {
  getOutlet: (params) => {
    const MARKET_URL = Constants.URL.MARKET_URL

    return Api.request({
      url: `${MARKET_URL}${params.outletId}/profile`
    })
  },
  getBusiness: (params) => {
    const BUSINESS_URL = Constants.URL.BUSINESS_URL

    return Api.request({
      url: `${BUSINESS_URL}${params.businessId}`
    })
  },
  filterOutlet: (params) => {
    const MARKET_URL = Constants.URL.MARKET_URL

    return Api.request({
      url: `${MARKET_URL}filter`,
      data: params
    })
  }
}
